import script from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=ts"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=3b5598ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5598ec"]])

export default __exports__